module.exports = __webpack_public_path__ + "img/maestro.6c313f54.svg";